module.exports = __webpack_public_path__ + "1_0_60/img/taskpal.4cca17ae.svg";